import React, { useState, useEffect } from "react";
import Switch from '@mui/material/Switch';
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import FormControlLabel from '@mui/material/FormControlLabel';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@mui/material";
import Menu from '@mui/material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditOutlined from '@mui/icons-material/EditOutlined';
import ScheduleOutlined from '@mui/icons-material/ScheduleOutlined';
import AccountCircleOutlined from '@mui/icons-material/AccountCircleOutlined';
import MailOutlineOutlined from '@mui/icons-material/MailOutlineOutlined';
import LockOutlined from '@mui/icons-material/LockOutlined';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  Alert,
  Grid,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";

function ActionMenu({ user, onEdit, onChangePassword }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [submenuAnchorEl, setSubmenuAnchorEl] = useState(null);
  const navigate = useNavigate();

  const platformUrls = {
    all: `/schedule-posts?userId=${user.id}`,
    instagram: `/schedule-posts/instagram?userId=${user.id}`,
    youtube: `/schedule-posts/youtube?userId=${user.id}`,
    facebook: `/schedule-posts/facebook?userId=${user.id}`,
    linkedin: `/schedule-posts/linkedin?userId=${user.id}`,
  };

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => {
    setAnchorEl(null);
    setSubmenuAnchorEl(null); // Ensure submenu also closes
  };
  // Use the DOM node of MenuItem as the anchor
  const handleSubMenuOpen = (event) => setSubmenuAnchorEl(event.currentTarget);
  const handleSubMenuClose = () => setSubmenuAnchorEl(null);

  return (
    <>
      <IconButton size="small" onClick={handleMenuOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ elevation: 3 }}
      >
        <MenuItem
          onClick={() => {
            handleMenuClose();
            onEdit(user.id);
          }}
        >
          <ListItemIcon>
            <EditOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText>Edit</ListItemText>
        </MenuItem>

        {/* Corrected Submenu logic: anchor to "Post" MenuItem */}
        <MenuItem
          aria-haspopup="true"
          aria-controls="submenu"
          onClick={handleSubMenuOpen} // Optionally open submenu on click too
        >
          <ListItemIcon>
            <ScheduleOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Post"
            secondary="Schedule content for this user"
          />
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMenuClose();
            navigate(`/account/?userId=${user.id}`);
          }}
        >
          <ListItemIcon>
            <AccountCircleOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText>Account</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleMenuClose();
            navigate(`/messages/?userId=${user.id}`);
          }}
        >
          <ListItemIcon>
            <MailOutlineOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText>Message</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleMenuClose();
            onChangePassword(user.id);
          }}
        >
          <ListItemIcon>
            <LockOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText>Change Password</ListItemText>
        </MenuItem>
      </Menu>

      {/* The submenu: anchored to the actual "Post" MenuItem DOM node */}
      <Menu
        id="submenu"
        anchorEl={submenuAnchorEl}
        open={Boolean(submenuAnchorEl)}
        onClose={handleSubMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        MenuListProps={{
          // Properly closes submenu on mouse leave from menu, not the MenuItem!
          onMouseLeave: handleSubMenuClose,
        }}
      >
        {Object.keys(platformUrls).map((platform) => (
          <MenuItem
            key={platform}
            onClick={() => {
              handleSubMenuClose();
              handleMenuClose();
              navigate(platformUrls[platform]);
            }}
          >
            {platform.charAt(0).toUpperCase() + platform.slice(1)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

const UsersPage = () => {
  const [users, setUsers] = useState([]); // empty initially
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);
  const [statusMessage, setStatusMessage] = useState({ text: "", type: "" });

  const [formAction, setFormAction] = useState("add"); // "add" or "edit"
  const [editId, setEditId] = useState(null);


  const [formUserType, setFormUserType] = useState(""); // tracks userType for the form
  const [formData, setFormData] = useState({
    agencyId: "",
    planId: "",
    name: "",
    username: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    gstNumber: "",
    gstState: "",
    companyName: "",
    panNumber: "",
    companyAddress: ""
  });
  const [agencyDetails, setAgencyDetails] = useState(null);
  const [userAllocateMessages, setUserAllocateMessages] = useState(0);
  const [userAllocatePosts, setUserAllocatePosts] = useState(0);
  const [userPostDone, setUserPostDone] = useState(0);
  const [userMessageDone, setUserMessageDone] = useState(0);

  const [agencyAllocateMessages, setAgencyAllocateMessages] = useState(0);
  const [agencyAllocatePosts, setAgencyAllocatePosts] = useState(0);
  const [agencyPostDone, setAgencyPostDone] = useState(0);
  const [agencyMessageDone, setAgencyMessageDone] = useState(0);

  const [postsAllocationDenominator, setPostsAllocationDenominator] = useState(0);
  const [messagesAllocationDenominator, setMessagesAllocationDenominator] = useState(0);


  const [messageError, setMessageError] = useState('');
  const [postError, setPostError] = useState('');

  const [formError, setFormError] = useState("");
  const loggedInUserType = localStorage.getItem("userType") || "";
  const [dialogLoading, setDialogLoading] = useState(false);

  // ---- handleOpenDialog: open dialog for "add" and initialize state ----
  const handleUserDialog = async (id = null) => {
    localStorage.setItem('id', id);
    setOpen(true); // Open dialog immediately
    setDialogLoading(true); // Show loading spinner
    try {
      setFormError(""); // Clear previous errors
      const token = localStorage.getItem("token");
      // Always get agency details (agency_id from formData)
      const agencyIdToSend = id !== null ? id : formData.agencyId;
      const resAgency = await fetch("https://socialmedia.gtlit.com/api/get_agency_details", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({ agency_id: agencyIdToSend, token }),
      });
      if (!resAgency.ok) throw new Error("Failed to fetch agency");
      const dataAgency = await resAgency.json();
      if (!dataAgency || !dataAgency.status) {
        throw new Error(dataAgency?.message || "Failed to load agency");
      }

      // If edit, also get user and prefill data
      if (id != null) {
        const resUser = await fetch("/api/get_specific_user", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify({ id, token })
        });
        if (!resUser.ok) throw new Error("Failed to fetch user");
        const dataUser = await resUser.json();
        if (!dataUser || !dataUser.status) {
          throw new Error(dataUser?.message || "Failed to load user");
        }

        const user = dataUser.user || {};
        const userDetails = dataUser.userDetails || {}; 
        setFormData({
          agencyId: formData.agencyId,
          planId: user.activePlanId || "",
          name: user.name || "",
          username: user.username || "",
          email: user.email || "",
          phone: user.phone || "",
          password: "",
          confirmPassword: "",
          gstNumber: user.gstNumber || "",
          gstState: user.gstState || "",
          companyName: user.companyName || "",
          panNumber: user.panNumber || "",
          companyAddress: user.companyAddress || ""
        });

        setFormUserType(user.userType || "");
        setUserAllocateMessages(Number(userDetails.totalMessagesAllocated || 0));
        setUserAllocatePosts(Number(userDetails.totalPostsAllocated || 0));
        setUserPostDone(Number(userDetails.totalPostsDone || 0));
        setUserMessageDone(Number(userDetails.totalMessagesDone || 0));


        setAgencyAllocateMessages(Number(dataAgency.total_messages_allocated || 0));
        setAgencyAllocatePosts(Number(dataAgency.total_posts_allocated || 0)); 
        setAgencyPostDone(Number(dataAgency.total_posts_done || 0));           
        setAgencyMessageDone(Number(dataAgency.total_messages_done || 0));  
        
        // EDIT MODE: denominator includes user’s current allocation
        setPostsAllocationDenominator(
          (Number(dataAgency.total_posts_allocated ?? 0) - Number(dataAgency.total_posts_done ?? 0)) +
          Number(userDetails.totalPostsAllocated ?? 0)
        );
        setMessagesAllocationDenominator(
          (Number(dataAgency.total_messages_allocated ?? 0) - Number(dataAgency.total_messages_done ?? 0)) +
          Number(userDetails.totalMessagesAllocated ?? 0)
        );
        setMessageError("");
        setPostError("");
        setFormAction("edit");
        setEditId(user.id);
      } else {
        // For create, reset fields (like your handleOpenDialog does)
        setPostsAllocationDenominator(
          Number(dataAgency.total_posts_allocated ?? 0) - Number(dataAgency.total_posts_done ?? 0)
        );
        setMessagesAllocationDenominator(
          Number(dataAgency.total_messages_allocated ?? 0) - Number(dataAgency.total_messages_done ?? 0)
        );
        setFormData({
          agencyId: formData.agencyId,
          planId: "",
          name: "",
          username: "",
          email: "",
          phone: "",
          password: "",
          confirmPassword: "",
          gstNumber: "",
          gstState: "",
          companyName: "",
          panNumber: "",
          companyAddress: ""
        });
        setFormUserType(loggedInUserType === "2" ? "3" : "");
        setUserAllocateMessages(0);
        setUserAllocatePosts(0);
        setMessageError("");
        setPostError("");
        setEditId(null);
        setFormAction("add");
      }
      setAgencyDetails(dataAgency || null);
      setDialogLoading(false); // Hide loading, show form

    } catch (err) {
      console.error(err);
      setFormError("Failed to load user/agency data.");
      setDialogLoading(false);
    }
  };

  // Determine if extra agency fields should be visible
  const showAgencyFields = loggedInUserType !== "2" && formUserType === "2";

  // Determine if User Role dropdown should be visible
  const showUserRoleDropdown = loggedInUserType !== "2";

  const [AGENCY_OPTIONS, setAgencyOptions] = useState([]);
  const [PLAN_OPTIONS, setPlanOptions] = useState([]);

  useEffect(() => {
    // Only call API when Agency User is selected and a valid agency picked
    if (formUserType === "3" && formData.agencyId) {
      fetch('/api/get_agency_details', {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": "Bearer " + localStorage.getItem("token") },
        body: JSON.stringify({ agency_id: formData.agencyId, token: localStorage.getItem("twitter_token") }),
      })
        .then(res => res.json())
        .then(data => {
          setAgencyDetails(data);
          setUserAllocateMessages(0);
          setUserAllocatePosts(0);
          setMessageError('');
          setPostError('');
        })
        .catch(() => setAgencyDetails(null));
    } else {
      setAgencyDetails(null);
    }
  }, [formUserType, formData.agencyId]);

  useEffect(() => {
    if (formUserType) {
      const jwt = localStorage.getItem("token");
      fetch(`/api/get_plans_by_user_type?user_type=${formUserType}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${jwt}`,
          "Content-Type": "application/json",
        },
      })
        .then(res => res.json())
        .then(data => {
          const options = (data.plans || []).map(plan => ({
            id: plan.id,
            name: plan.name
          }));
          setPlanOptions(options);
        })
        .catch(() => setPlanOptions([]));
    }
  }, [formUserType]);

  useEffect(() => {
    if (formUserType === "3") {
      fetch("/api/get_all_agency")
        .then(res => res.json())
        .then(data => {
          const options = (data || []).map(agency => ({
            id: agency.id,
            name: agency.username || agency.name || `Agency ${agency.id}`
          }));
          setAgencyOptions(options);
        })
        .catch(() => setAgencyOptions([]));
    }
  }, [formUserType]);

  const handleToggleStatus = async (id) => {
    setUsers((prevUsers) =>
      prevUsers.map((user) =>
        user.id === id
          ? { ...user, status: Number(user.status) === 1 ? 0 : 1 }
          : user
      )
    );

    // Determine new status value using the optimistic state (previously computed)
    const updatedUser = users.find(u => u.id === id);
    const newStatus = Number(updatedUser.status) === 1 ? 0 : 1;

    try {
      const token = localStorage.getItem("token");
      const response = await fetch("/api/status_update", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({ id, status: newStatus }),
      });

      if (!response.ok) throw new Error();

      setStatusMessage({ text: "Status updated successfully!", type: "success" });

    } catch (error) {
      setUsers((prevUsers) =>
        prevUsers.map((user) =>
          user.id === id
            ? { ...user, status: Number(user.status) === 1 ? 0 : 1 }
            : user
        )
      );
      setStatusMessage({ text: "Failed to update status. Please try again.", type: "error" });
    }
  };

  //Auto Hide Status Message
  useEffect(() => {
    if (statusMessage.text) {
      const timer = setTimeout(() => setStatusMessage({ text: "", type: "" }), 3000);
      return () => clearTimeout(timer);
    }
  }, [statusMessage]);

  // Fetch users from backend API
  const fetchUsers = async () => {
    try {
      setLoading(true);
      setError("");

      const token = localStorage.getItem("token");

      const res = await fetch(`/api/get_all_users?token=${encodeURIComponent(token)}`, {
        method: "POST",
      });

      if (!res.ok) {
        throw new Error(`Server responded with status ${res.status}`);
      }

      const data = await res.json();
      setUsers( data || []);
    } catch (err) {
      console.error("Error fetching users:", err);
      setError("Failed to load users. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

 const handleAllocateMessages = (e) => {
  const value = Number(e.target.value);
  const minValue = userMessageDone;
  const maxValue = messagesAllocationDenominator;

  let newValue = value;

  if (value > maxValue) {
    newValue = maxValue;
  } else if (value < minValue) {
    newValue = minValue;
  }
  setUserAllocateMessages(newValue);
  setMessageError('');
};

const handleAllocatePosts = (e) => {
  const value = Number(e.target.value);
  const minValue = userPostDone;
  const maxValue = postsAllocationDenominator;

  let newValue = value;

  if (value > maxValue) {
    newValue = maxValue;
  } else if (value < minValue) {
    newValue = minValue;
  }
  setUserAllocatePosts(newValue);
  setPostError('');
};



  useEffect(() => {
    fetchUsers();
  }, []);

  // --- submission handler used for both add and edit ---
  const handleSubmit = async () => {
    setFormError("");
    const token = localStorage.getItem("token");
    const payload = {
      ...formData,
      userType: formUserType,
      allocatedMessages: formUserType === "3" ? userAllocateMessages : null,
      allocatedPosts: formUserType === "3" ? userAllocatePosts : null,
      action: formAction,
      id: formAction === "edit" ? editId : null,
      token
    };

    try {
      const res = await fetch("/api/save_new_user", {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });
      if (!res.ok) {
        throw new Error("Failed to save user");
      }
      const body = await res.json();
      if (!body.status) {
        setFormError(body.message || "Save failed");
      } else {
        setOpen(false);
        fetchUsers();
      }
    } catch (err) {
      console.error(err);
      setFormError("Failed to save user");
    }
  };
  const clampToRange = (value, min, max) => Math.max(min, Math.min(max, value));
const user_type_display = ["" , "Admin" , "Agency", "AgencyUser" , "Individual"  ];


  return (
    <Container
      maxWidth="100vw"
      sx={{
        minHeight: "100vh",
        py: 5,
      }}
    >
      <Button
        variant="contained"
        color="primary"
        sx={{ float: "right", mb: 2 }}
        onClick={() => handleUserDialog()}
      >
        Create User
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            boxShadow: "0 8px 32px rgba(90,24,154,0.13)",
            background: "linear-gradient(135deg,#f3f0ff 60%,#ede9fe 100%)",
            p: 2,
            border: "1px solid #d1c4e9",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 800,
            color: "#5a189a",
            textAlign: "center",
            letterSpacing: 1.2,
            fontSize: 26,
            pb: 1,
          }}
        >
          {formAction === "edit" ? "Edit User" : "Create User"} (
          {formUserType === "2"
            ? "Agency"
            : formUserType === "4"
              ? "Individual"
              : formUserType === "3"
                ? "Agency User"
                : "Unknown"}
          )
        </DialogTitle>
        <Divider sx={{ mb: 2 }} />
        <DialogContent>
          {dialogLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={2}>
              {showUserRoleDropdown && (
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth sx={{ minWidth: 150 }}>
                    <InputLabel id="user-type-label">User Role</InputLabel>
                    <Select
                      labelId="user-type-label"
                      value={formUserType}
                      label="User Role" // this allows the label float to work
                      onChange={e => setFormUserType(e.target.value)}
                      sx={{ minWidth: 150 }} // optional, to directly style the Select
                    >
                      <MenuItem value="2">Agency</MenuItem>
                      <MenuItem value="4">Individual User</MenuItem>
                      <MenuItem value="3">Agency User</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}

              {formUserType === "3" && loggedInUserType !== "2" && (
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth sx={{ minWidth: 200 }}>
                    <InputLabel id="agency-label">Select Agency</InputLabel>
                    <Select
                      labelId="agency-label"
                      label="Select Agency"
                      value={formData.agencyId}
                      onChange={e =>
                        setFormData(f => ({ ...f, agencyId: e.target.value }))
                      }
                      sx={{ minWidth: 200 }}
                    >
                      {AGENCY_OPTIONS.map(option => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                </Grid>
              )}

              <Grid item xs={12}>
                <TextField
                  label="Name"
                  fullWidth
                  size="medium"
                  InputProps={{
                    sx: { borderRadius: 2, background: "#f7f3fa" },
                  }}
                  value={formData.name}
                  onChange={e => setFormData(f => ({ ...f, name: e.target.value }))}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Username"
                  fullWidth
                  size="medium"
                  InputProps={{
                    sx: { borderRadius: 2, background: "#f7f3fa" },
                  }}
                  value={formData.username}
                  onChange={e => setFormData(f => ({ ...f, username: e.target.value }))}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Email Address"
                  fullWidth
                  size="medium"
                  InputProps={{
                    sx: { borderRadius: 2, background: "#f7f3fa" },
                  }}
                  value={formData.email}
                  onChange={e => setFormData(f => ({ ...f, email: e.target.value }))}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Phone Number"
                  fullWidth
                  size="medium"
                  InputProps={{
                    sx: { borderRadius: 2, background: "#f7f3fa" },
                  }}
                  value={formData.phone}
                  onChange={e => setFormData(f => ({ ...f, phone: e.target.value }))}
                />
              </Grid>
              {formAction !== "edit" && (
                <>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Password"
                      type="password"
                      fullWidth
                      size="medium"
                      InputProps={{
                        sx: { borderRadius: 2, background: "#f7f3fa" },
                      }}
                      value={formData.password}
                      onChange={e => setFormData(f => ({ ...f, password: e.target.value }))}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Confirm Password"
                      type="password"
                      fullWidth
                      size="medium"
                      InputProps={{
                        sx: { borderRadius: 2, background: "#f7f3fa" },
                      }}
                      value={formData.confirmPassword}
                      onChange={e => setFormData(f => ({ ...f, confirmPassword: e.target.value }))}
                    />
                  </Grid>
                </>
              )}
              {formUserType !== "3" && (
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth sx={{ minWidth: 200 }}>
                    <InputLabel id="plan-label">Select Plan</InputLabel>
                    <Select
                      labelId="plan-label"
                      label="Select Plan" // makes the floating label work as intended
                      value={formData.planId || ""}
                      onChange={e => setFormData(f => ({ ...f, planId: e.target.value }))}
                      sx={{ minWidth: 200 }} // ensures dropdown is always wide enough
                    >
                      {PLAN_OPTIONS.map(option => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                </Grid>
              )}
              {((formUserType === "3" && agencyDetails) || (loggedInUserType === "2" && formAction === "edit" && agencyDetails) || (formAction === "Create User" && agencyDetails)) && (
                <>
                                    <Grid item xs={12} sm={6}>
                    <Typography sx={{ mb: 1 }}>
                      {userAllocateMessages}/{messagesAllocationDenominator} Messages
                    </Typography>
                    <TextField
                      label="Allocate Messages"
                      type="number"
                      fullWidth
                      value={userAllocateMessages}
                      onChange={handleAllocateMessages}
                      inputProps={{ 
                        min: userMessageDone, 
                        max: messagesAllocationDenominator 
                      }}
                      error={!!messageError}
                      helperText={messageError || `Min: ${userMessageDone}, Max: ${messagesAllocationDenominator}`}
                      onBlur={() => setUserAllocateMessages(clampToRange(userAllocateMessages, userMessageDone, messagesAllocationDenominator))}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={{ mb: 1 }}>
                      {userAllocatePosts}/{postsAllocationDenominator} Posts
                    </Typography>
                    <TextField
                      label="Allocate Posts"
                      type="number"
                      fullWidth
                      value={userAllocatePosts}
                      onChange={handleAllocatePosts}
                      inputProps={{ 
                        min: userPostDone, 
                        max: postsAllocationDenominator 
                      }}
                      error={!!postError}
                      helperText={postError || `Min: ${userPostDone}, Max: ${postsAllocationDenominator}`}
                      onBlur={() => setUserAllocateMessages(clampToRange(userAllocatePosts, userPostDone, postsAllocationDenominator))}
                    />
                  </Grid>
                </>
              )}

              {showAgencyFields && (
                <>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="GST Number"
                      fullWidth
                      size="medium"
                      InputProps={{
                        sx: { borderRadius: 2, background: "#f7f3fa" },
                      }}
                      value={formData.gstNumber}
                      onChange={e => setFormData(f => ({ ...f, gstNumber: e.target.value }))}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="GST State"
                      fullWidth
                      size="medium"
                      InputProps={{
                        sx: { borderRadius: 2, background: "#f7f3fa" },
                      }}
                      value={formData.gstState}
                      onChange={e => setFormData(f => ({ ...f, gstState: e.target.value }))}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Company Name"
                      fullWidth
                      size="medium"
                      InputProps={{
                        sx: { borderRadius: 2, background: "#f7f3fa" },
                      }}
                      value={formData.companyName}
                      onChange={e => setFormData(f => ({ ...f, companyName: e.target.value }))}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Pan Number"
                      fullWidth
                      size="medium"
                      InputProps={{
                        sx: { borderRadius: 2, background: "#f7f3fa" },
                      }}
                      value={formData.panNumber}
                      onChange={e => setFormData(f => ({ ...f, panNumber: e.target.value }))}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      label="Company Address"
                      fullWidth
                      size="medium"
                      InputProps={{
                        sx: { borderRadius: 2, background: "#f7f3fa" },
                      }}
                      value={formData.companyAddress}
                      onChange={e =>
                        setFormData(f => ({ ...f, companyAddress: e.target.value }))
                      }
                    />
                  </Grid>
                </>
              )}
            </Grid>
          )}
          {formError && (
            <Alert
              severity="error"
              sx={{
                mt: 3,
                fontWeight: 500,
                borderRadius: 2,
                background: "#ffffff",
                color: "#d32f2f",
              }}
            >
              {formError}
            </Alert>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => setOpen(false)}
            variant="outlined"
            sx={{
              borderRadius: 2,
              color: "#5a189a",
              borderColor: "#c77dff",
              fontWeight: 600,
              px: 2,
              textTransform: "none",
              background: "#faf5ff",
              "&:hover": { background: "#e0c3fc" },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            {formAction === "edit" ? "Save Changes" : "Create"}
          </Button>
        </DialogActions>
      </Dialog>
      {statusMessage.text && (
        <Box sx={{ mb: 2 }}>
          <Alert
            severity={statusMessage.type}
            onClose={() => setStatusMessage({ text: "", type: "" })}
          >
            {statusMessage.text}
          </Alert>
        </Box>
      )}
      <Typography
        variant="h4"
        component="h1"
        gutterBottom
        align="center"
        sx={{
          fontWeight: 700,
          color: "#5a189a",
          letterSpacing: 1.5,
        }}
      >
        Users
      </Typography>

      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" my={5}>
          <CircularProgress color="secondary" />
        </Box>
      ) : error ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      ) : (
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: 3,
            boxShadow: 3,
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", color: "#000" }}>S No.</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#000" }}>USERTYPE</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#000" }}>Name</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#000" }}>Username</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#000" }}>Email</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#000" }}>Phone</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#000" }}>Status</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#000" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
             {users.length > 0 ? (
  users.map((user, index) => (
    <TableRow
      key={user.id}
      hover
      sx={{
        "&:nth-of-type(even)": { backgroundColor: "#f5f5fa" },
      }}
    >
      <TableCell>{index + 1}</TableCell>
                    <TableCell>{user_type_display[user.userType] ?? ""}</TableCell>
                    <TableCell sx={{ fontWeight: 500 }}>{user.name}</TableCell>
                    <TableCell>{user.correctUsername}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell sx={{ whiteSpace: "nowrap" }}>{user.phone}</TableCell>
                    <TableCell>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={Number(user.status) === 1}
                            onChange={() => handleToggleStatus(user.id)}
                            color="success"
                            sx={{
                              "& .MuiSwitch-switchBase.Mui-checked": {
                                color: "#38b000",
                              },
                              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                backgroundColor: "#38b000",
                                opacity: 1,
                              },
                              "& .MuiSwitch-switchBase": {
                                transition: "all 0.3s cubic-bezier(.4,2,.5,.5)",
                              },
                            }}
                          />
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <ActionMenu
                        user={user}
                        onEdit={() => handleUserDialog(user.id)}
                        onChangePassword={(id) => {/* open change password dialog with id */ }}
                      />
                    </TableCell>

                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    No users found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Container>
  );
};
export default UsersPage;
